export type FormMetadata = {
  form_filled: boolean;
  questions: FormItem[];
  show_form_after_fill: boolean;
};

export type Condition = {
  condition_type: string;
  boolean_operator: boolean;
  values: string[];
  operator: string;
  connector: string;
  connected_question_guid: string;
};

export type Option = {
  guid: string;
  text: string | number;
  exclusive?: boolean;
  active?: boolean;
};

export type Question = {
  question_index: number;
  text: string;
  guid: string;
  show_description?: boolean;
  mandatory?: boolean;
  description?: string;
  question_key: string;
  show_question: boolean;
  rendered?: boolean;
  question_type: string;
  options?: Option[];
  question_conditions?: Condition[];
  appeared_conditions?: Condition[];
  min_value?: number;
  max_value?: number;
  field_type?: string;
  display_type?: string;
  multiple_select?: boolean;
  answer?: Option[];
  scale_min_text?: string;
  scale_max_text?: string;
  scale_num_options?: number;
  formula?: string;
  answer_depends_on_question?: boolean;
  dependency_question_guid?: string;
  dependency_operator?: string;
  date_comparison_enabled?: boolean;
  date_comparison_operator?: string;
  measurement_unit?: string; // Optional unit label for number field (e.g. "מ\"ל", "kg") - displayed next to input
};

/** Structural item that splits the form into pages; not answerable, has no question_key. */
export type PageBreak = {
  question_type: 'page_break';
  guid: string;
  question_index: number;
  show_question: boolean;
};

/** Heterogeneous list item: either an answerable Question or a structural PageBreak. */
export type FormItem = Question | PageBreak;

/** Type guard — narrows a FormItem to PageBreak. */
export function isPageBreak(item: FormItem): item is PageBreak {
  return item.question_type === 'page_break';
}

export enum QuestionType {
  RADIO = 'radio',
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  TEXT = 'text',
  HEADER = 'header',
  SCALE = 'scale',
  PAGE_BREAK = 'page_break',
}

export enum Operators {
  GREATER_THAN = 'greater_than',
  LESS_THAN = 'less_than',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not_contains',
  IN = 'in',
  GREATER_EQUAL = 'greater_equal',
  LESS_EQUAL = 'less_equal',
}

export enum ConditionConnector {
  FIRST = 'first',
  AND = 'and',
  OR = 'or',
}
